import gql from "graphql-tag"

const DELETE_ORDER = gql`
  mutation deleteOrder($orderId: ID!) {
    Order {
      deleteOrder(orderId: $orderId)
    }
  }
`

export default DELETE_ORDER
